import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";
import { useFlavour } from "@/shared/flavours/useFlavour";
import { useTheme } from "@/shared/styles/useTheme";
import Styles from "./Header.module.scss";

const Logo = () => {
  const { primaryColorBorder } = useTheme();
  const { RemindmeLogo, PartnerLogo, partnerLink } = useFlavour();

  const handleClick = () => {
    window.scrollTo(0, 0);
    window.location.href = "/";
  };
  return (
    <div className={Styles.headerCompanyLogoDesktopContainer}>
      {PartnerLogo && (
        <Link className={Styles.headerLink} to={partnerLink}>
          <img
            src={PartnerLogo}
            className={Styles.headerCompanyLogoDesktop}
            height={"40px"}
            width={"120px"}
            alt="partner logo"
          />
        </Link>
      )}
      {PartnerLogo && RemindmeLogo && <div className={classNames(Styles.splitting, primaryColorBorder)} />}
      {RemindmeLogo && (
        <>
          <Link to={"/"} onClick={handleClick}>
            <img
              src={RemindmeLogo}
              className={classNames(Styles.headerCompanyLogoDesktop, {
                [Styles.headerCompanySublogoDesktop]: PartnerLogo && RemindmeLogo,
              })}
              height={"40px"}
              width={"121px"}
              alt="remind.me header logo"
            />
          </Link>
        </>
      )}
    </div>
  );
};

export default Logo;
